import React from "react";
import { Link } from "react-router-dom";
import { BackIcon } from "../../../../components/icons";
import { useBookingEditText } from "../text";
import { BiSolidPencil } from "react-icons/bi";
import { cn } from "../../../../utils/classnames";

const BookingHeader = ({ id, requestId, customer, bookingKey, onDiscardClick, bookingStatus = "CONFIRMED", paymentStatus = "CHARGE_PENDING" }) => {
    const { t } = useBookingEditText();
    const STATUS_MAP = {
        CONFIRMED: { label: "Confirmed", className: "tw:bg-[#3CAEA3]" },
        CANCELLED: { label: "Cancelled", className: "tw:bg-[#EA4335]" },
        PENDING: { label: "Pending Confirmation", className: "tw:bg-[#F6BB2A]" },
    };

    const fallbackPath = requestId
        ? `/admin/bookinglist/edit/v2/${id}/modification-history/${requestId}`
        : id
            ? `/admin/bookinglist/edit/v2/${id}`
            : "/admin/bookinglist";

    const normalizedStatus = String(bookingStatus || "").toUpperCase();
    const normalizedPaymentStatus = String(paymentStatus || "").toUpperCase();
    const isChargedPayment = ["CHARGED", "ADDED_TO_MONTHLY_TOTAL"].includes(normalizedPaymentStatus);
    const effectiveStatus =
        normalizedStatus === "CANCELLED"
            ? "CANCELLED"
            : normalizedStatus === "CONFIRMED" && isChargedPayment
                ? "CONFIRMED"
                : "PENDING";
    const statusMeta = STATUS_MAP[effectiveStatus] || STATUS_MAP.PENDING;

    return (
        <div className="tw:flex tw:flex-wrap tw:items-center tw:gap-6 tw:pb-[28px] tw:lg:pb-[42px] tw:px-5 tw:pt-8 tw:border-b tw:border-[#e8e8e8] tw:mb-5">
            <Link
                to={fallbackPath}
                className="tw:inline-flex tw:items-center tw:gap-[10px] tw:rounded-[5px] tw:border tw:border-[#e8e8e8] tw:bg-[#e8e8e8] tw:px-3 tw:py-2 tw:text-[#282828] tw:!no-underline"
            >
                <BackIcon color="#8D8D8D" width={7} height={10} />
                <span className="tw:!font-hanken-grotesk tw:text-[#282828] tw:text-[14px]">
                    {t("editBooking.BookingEditPage.header.back")}
                </span>
            </Link>

            <div className="tw:flex tw:flex-1 tw:items-center tw:justify-between tw:gap-4">
                <div className="tw:flex tw:flex-col">
                    <div className="tw:!font-hanken-grotesk tw:font-[500] tw:text-[14px] tw:text-[#7c7b7b]">
                        {t("editBooking.BookingEditPage.header.bookingFor", {
                            customerName: `${customer?.pronounced} ${customer?.name}`,
                            bookingId: bookingKey,
                        })}
                    </div>
                    <div className="tw:!font-hanken-grotesk tw:text-[24px] tw:font-[500] tw:leading-normal tw:text-[#212529]">
                        {t("editBooking.BookingEditPage.header.editBooking")}
                    </div>
                </div>

                <div className="tw:flex tw:items-center tw:gap-2">
                    <span
                        className={cn(
                            "tw:inline-flex tw:h-[45px] tw:items-center tw:justify-center tw:whitespace-nowrap tw:rounded-[5px] tw:px-6 tw:text-[15px] tw:leading-[22px] tw:text-white",
                            statusMeta.className
                        )}
                    >
                        {statusMeta.label}
                    </span>

                    <button
                        type="button"
                        onClick={onDiscardClick}
                        className="tw:!no-underline"
                    >
                        <div className="tw:inline-flex tw:h-[45px] tw:items-center tw:justify-center tw:gap-2 tw:rounded-[5px] tw:border tw:border-[#D9D9D9] tw:bg-[#F9F9F9] tw:px-5">
                            <BiSolidPencil size={14} color="#282828" />
                            <span className="tw:font-hanken-grotesk tw:text-[15px] tw:font-normal tw:leading-[22px] tw:text-[#282828]">
                                {t("editBooking.BookingEditPage.button.discardEdit")}
                            </span>
                        </div>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BookingHeader;
